import { AreaItem } from '@/types/cms/AreaItem'
import { Icon } from '@/components/Icon'
import React from 'react'
import { clsx } from 'clsx'
import styles from './TypeVisualizer.module.scss'
import VideoLabel from '@/components/Video/VideoLabel'
import GalleryLabel from '@/components/GalleryLabel/GalleryLabel'

const TypeVisualizer = ({
  item,
  position = 'bottom-right',
  className,
}: {
  item: AreaItem
  position?: 'top-left' | 'bottom-right'
  className?: string
}) => {
  return (
    <>
      {item.type === 'video' && (
        <VideoLabel
          className={clsx(styles['video-container'], styles[position], className)}
          duration={item.model.durationMillis}
        />
      )}
      {item.type === 'gallery' && (
        <GalleryLabel
          count={item.model.galImgCount}
          className={clsx(styles['gallery-container'], styles[position], className)}
        />
      )}
    </>
  )
}

export default TypeVisualizer
